import { render } from "./AdminTicketReply.vue?vue&type=template&id=393af00a"
import script from "./AdminTicketReply.vue?vue&type=script&lang=js"
export * from "./AdminTicketReply.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__